import React, { useEffect, useState } from 'react';
import './StructuresAutoComplete.scss';
import { Autocomplete } from '../../../../ps-aspect-design';

export default function StructuresAutoComplete(props) {
  const {
    structures,
    onSelectionChange,
    disabled,
    onInputChange: inputChangeProp,
    value: valueProp,
    salaryRangeLabel
  } = props;
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [timeoutRef, setTimeoutRef] = useState();

  useEffect(() => {
    if (!valueProp) {
      setValue('');
      setSuggestions([]);
    } else {
      setValue(valueProp);
    }
  }, [valueProp]);

  const onInputChange = (newInput = '') => {
    setValue(newInput);
    setIsLoading(true);
    if (timeoutRef) {
      clearTimeout(timeoutRef);
    }
    setTimeoutRef(
      setTimeout(() => {
        let newSuggestions = [];
        for (let structure of structures) {
          if (!newInput) break;
          const match = structure.label?.toLowerCase().includes(newInput?.toLowerCase());
          if (match) newSuggestions.push(structure.label);
          if (newSuggestions.length >= 20) break;
        }

        setSuggestions(newSuggestions);
        setIsLoading(false);
      }, 250)
    );
    inputChangeProp(newInput);
  };

  const onSelectionSelect = suggestion => {
    const structure = structures.find(structure => structure.label === suggestion);
    onSelectionChange(structure);
    setValue(suggestion);
  };

  const onClear = () => {
    setValue('');
    setSuggestions([]);
    onSelectionChange(null);
  };

  return (
    <>
      <Autocomplete
        className="structures-autocomplete"
        isLoading={isLoading}
        onClear={onClear}
        onInputChange={onInputChange}
        onSelectionChange={onSelectionSelect}
        placeholder={`Search for ${salaryRangeLabel}...`}
        suggestions={suggestions}
        value={value}
        disabled={disabled}
      />
    </>
  );
}
